module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-700.ca74bbf4.woff";